// extracted by mini-css-extract-plugin
module.exports = {"lecture":"styles_lecture__2_oqC","lecture__time":"styles_lecture__time__317Fz","lecture__info":"styles_lecture__info__-J8FO","lecture__title":"styles_lecture__title__1DUZD"};